import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SharedService} from 'app/shared/shared.service';
import {Router} from '@angular/router';
import * as moment from 'moment';
import {LocalStorageService} from 'angular-2-local-storage';

@Component({
  selector: 'app-payment-receipt',
  templateUrl: './payment-receipt.component.html',
  styleUrls: ['./payment-receipt.component.css']
})
export class PaymentReceiptComponent implements OnInit {

  @Input('paymentReceipt') paymentReceipt: any;
  isExpressPay = false;
  @Input('paymentAmount') paymentAmount: any;
  @Output('onRetryPayment') onRetryPayment: EventEmitter<any> = new EventEmitter<any>();
  displayDate = undefined;
  constructor(
    private router: Router,
    private sharedService: SharedService,
    private localStorageService: LocalStorageService
  ) {
	this.isExpressPay = this.localStorageService.get('is_express_pay')
    this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
      .then((res) => {
        if (res.status === 'success' && res.isTerminated === false) {
          const person = res.results[0]['personal'][0];
          sharedService.setHeaderUserLoggedIn('payment_successful', true, person);
        } else {
			sharedService.setHeaderTitle('payment_successful');
		}
      })
    this.displayDate = moment().format('MM/DD/YYYY');
  }

  ngOnInit() {
  }
  retryPayment() {
    this.onRetryPayment.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/paymentus/make-payment/receipt/payment-receipt/payment-receipt.component.ts